// Skeleton.jsx
export const Skeleton = ({
  width = "100%",
  height = "20px",
  circle = false,
}) => {
  return (
    <>
      <div
        className="skeleton"
        style={{
          width,
          height,
          borderRadius: circle ? "50%" : "0.375rem",
        }}
      />
      <style>
        {`
            .skeleton {
                position: relative;
                overflow: hidden;
                background: #e5e7eb;
                border-radius: 0.375rem;
            }

            .skeleton::after {
                content: "";
                position: absolute;
                inset: 0;
                transform: translateX(-100%);
                background: linear-gradient(
                    90deg,
                    transparent,
                    rgba(255, 255, 255, 0.4),
                    transparent
                );

                animation: shimmer 1.5s infinite;
            }

            @keyframes shimmer {
                100% {
                    transform: translateX(100%);
                }
            }
            `}
      </style>
    </>
  );
};
